"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineTypeJSONModel = exports.LineType = void 0;
var LineType;
(function (LineType) {
    LineType["nonCumulative"] = "nonCumulative";
    LineType["cumulative"] = "cumulative";
})(LineType = exports.LineType || (exports.LineType = {}));
class LineTypeJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetLineType();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            this.setLineType(serializedState);
        };
        this.serialize = () => {
            return this.lineType;
        };
        ////////////////////////////////////////////////
        // LineType
        ////////////////////////////////////////////////
        this.getLineType = () => this.lineType;
        this.setLineType = (value) => this.lineType = validateLineType(value);
        this.resetLineType = () => this.setLineType(undefined);
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.LineTypeJSONModel = LineTypeJSONModel;
const validateLineType = (value) => {
    if (typeof value === "string" && value in LineType) {
        return value;
    }
    return LineType.nonCumulative;
};
